export default __webpack_public_path__ + "static/affiliate-program-AffiliateApp@2x-9809373c9a058f870bbebd742f67b3f9.png";